<template>
    <div class="booking-alternatives">
        <Button v-if="!expanded" class="p-button p-button-secondary p-button-text"
         @click="showAlternatives = !showAlternatives" :label="dictionary.BookingFlowAlternativesToggle"
         :icon="!showAlternatives ? 'pi pi-angle-down' : 'pi pi-angle-up'" iconPos="right"></Button>
        <div v-if="showAlternatives || expanded" class="booking-alternatives__ctas">
            <a class="booking-alternatives__cta" v-if="waitingListLink" :href="waitingListLink + '?departmentId=' + departmentId">
                <img src="/assets/images/waitlist.svg" height="30" loading="lazy" alt="" />
                <p v-html="dictionary.BookingFlowAlternativesWaitlist"></p>
            </a>
            <a class="booking-alternatives__cta" v-if="supportLink" :href="supportLink">
                <img src="/assets/images/phone.svg"  height="30" loading="lazy" alt="" />
                <p v-html="dictionary.BookingFlowAlternativesSupport"></p>
            </a>
            <a class="booking-alternatives__cta" v-if="findOtherLink" :href="findOtherLink">
                <img src="/assets/images/greenBox.svg" height="30" loading="lazy" alt="" />
                <p v-html="dictionary.BookingFlowAlternativesFindOther"></p>
            </a>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
export default {
    name: "bookingAlternatives",
    props: ["departmentId","waitingListLink","supportLink","findOtherLink","expanded"],
    components: {
        Button
    },
    data() {
        return {
            dictionary: [],
            showAlternatives:false
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetBookingAlternativesDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });


    },
};
</script>
